import Handler from "../Handler";

class SpecialBetGameActiveStatusHandler extends Handler {
  execute(message) {
    let parsedData = JSON.parse(message);
    this.service.processGameDefinitionUpdateData(parsedData);
  }
}

export default SpecialBetGameActiveStatusHandler;